// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f71b579b","732":"4b1165e3"}[chunkId] + ".chunk.js";
};